import { Directive, ElementRef, Input, OnChanges } from '@angular/core';
import { config, MemberQuery, UserContext } from '@fgb/core';

@Directive({
  selector: '[campaignImage]',
})
export class CampaignImageDirective implements OnChanges {
  @Input() campaignImage!: number;

  constructor(
    private el: ElementRef<HTMLImageElement>,
    private memberQuery: MemberQuery
  ) {}

  ngOnChanges() {
    if (!this.campaignImage) return;

    let currentUser =
      this.memberQuery.getValue().user || ({ clubId: config.defaultClubId, lcid: config.defaultLcid } as UserContext);

    this.el.nativeElement.src = `${config.contentUrl}/image/campaign/${this.campaignImage}/${currentUser.clubId}/1`;
  }
}
